import type { AlwaysVatDeductibleBasicPricingValues } from "@slfinrtl/ui-bff-routes"
import type { CheckboxFieldProps } from "src/components/form"
import type { InputFieldProps } from "../../../form/input/InputField"

export interface AlwaysVatDeductibleBasicPricingFields {
	minimumPrice: InputFieldProps
	price: InputFieldProps
	purchasePrice: InputFieldProps
	vatDeductible?: CheckboxFieldProps
}

type FieldName = keyof AlwaysVatDeductibleBasicPricingValues

const priceName: FieldName = "price"
const minimumPriceName: FieldName = "minimumPrice"
const purchasePriceName: FieldName = "purchasePrice"
const vatDeductibleName: FieldName = "vatDeductible"

export const alwaysVatDeductibleBasicPricingFieldNames = {
	minimumPriceName,
	priceName,
	purchasePriceName,
	vatDeductibleName,
}
